import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { borderToShadows, THEME_UI_DEFAULT_KEY, utils, isFlatDesign, standardDisabled, standardButtonHover } from '@costar/theme-ui';

var _text;
var standardStyles = {
  borderRadius: 'default',
  fontWeight: 'normal',
  lineHeight: 'body',
  '&:not([type="checkbox"]):not([type="radio"])': {
    transition: 'box-shadow 0.15s ease-in-out'
  }
};
function standardActive(borderColor) {
  return _objectSpread2({
    boxShadow: 'unset',
    opacity: '1'
  }, borderColor ? {
    border: borderColor
  } : {});
}
function standardFocus(theme, borderColor) {
  var isFlatDesign$1 = isFlatDesign(theme);
  return _objectSpread2({
    zIndex: 2
  }, borderColor ? _objectSpread2({
    border: borderColor
  }, isFlatDesign$1 ? {} : {
    boxShadow: borderToShadows(borderColor)
  }) : {});
}
var standardStatic = {
  cursor: 'default'
};
var standardLoading = {
  '& #svg_spinner': {
    color: 'primary'
  }
};
var standardButtonDisabled = _objectSpread2(_objectSpread2({}, standardDisabled), {}, {
  bg: 'neutral.subtlest',
  color: 'neutral.dark',
  border: 'neutral.bold',
  '& .csg-tui-icon:last-child': {
    color: 'neutral.dark'
  }
});
var textDisabled = _objectSpread2(_objectSpread2({}, standardDisabled), {}, {
  color: 'neutral.dark',
  border: 0,
  '& .csg-tui-icon:last-child': {
    color: 'neutral.dark'
  }
});
var textHover = {
  backgroundColor: 'neutral.light'
};
function standardBehavior(theme, props, borderColor) {
  return !props.isStatic && !props.isLoading ? {
    cursor: 'pointer',
    // '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)':
    //   standardButtonHover,
    //'&:active:not(:disabled)': standardActive(borderColor),
    '&[disabled]': _objectSpread2(_objectSpread2({}, standardButtonDisabled), {}, {
      '& > span[role=button]': {
        cursor: 'not-allowed'
      }
    }),
    '&:focus': standardFocus(theme, borderColor),
    '&.is-toggled': standardFocus(theme, borderColor)
  } : _objectSpread2(_objectSpread2({}, standardStatic), props.isLoading ? standardLoading : {});
}
var textBehavior = function textBehavior(theme, props) {
  return _objectSpread2(_objectSpread2({}, standardBehavior(theme, props)), !props.isStatic && !props.isLoading ? {
    '&[disabled]': textDisabled,
    '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)': textHover
  } : {});
};
function standardTextVariant(theme, props) {
  return _objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles), textBehavior(theme, props)), {}, {
    '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)': textHover,
    '&:active:not(:disabled)': {
      bg: 'neutral.medium'
    },
    '&[disabled]': textDisabled,
    '&:focus': standardFocus(theme, 'primary'),
    '&.is-toggled': standardFocus(theme, 'primary'),
    border: 'transparent',
    color: 'text-light-bg',
    '& .csg-tui-icon:last-child': {
      color: 'black'
    }
  });
}
var standardGhostVariant = function standardGhostVariant(theme, props) {
  return _objectSpread2(_objectSpread2({
    borderRadius: 'default',
    border: 'transparent',
    bg: 'transparent'
  }, !props.isStatic && !props.isLoading ? {
    cursor: 'pointer',
    '&:hover:not(:disabled):not(.disable-hover)': _objectSpread2({}, props.hoverColor ? {
      color: props.hoverColor
    } : standardButtonHover),
    '&:active:not(:disabled)': standardActive('primary'),
    '&:focus': standardFocus(theme, 'primary'),
    '&[disabled]': standardButtonDisabled,
    '&.is-disabled': standardButtonDisabled
  } : _objectSpread2(_objectSpread2({}, standardStatic), props.isLoading ? standardLoading : {})), {}, {
    '&.is-selected': {
      bg: 'neutral.lighter'
    }
  });
};
var buttons = {
  primary: function primary(theme, props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles), standardBehavior(theme, props, 'primary')), {}, {
      bg: 'primary',
      border: 'transparent',
      color: 'white',
      '& .csg-tui-progress-spinner': {
        color: 'white'
      }
    }, !props.isStatic && !props.isLoading ? {
      '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)': {
        bg: 'primary.light',
        color: 'black'
      },
      '&:active:not(:disabled):not(:focus)': {
        bg: 'primary.moderate'
      }
    } : {});
  },
  secondary: function secondary(theme, props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles), standardBehavior(theme, props, 'primary')), {}, {
      bg: 'white',
      border: 'black',
      color: 'text-light-bg',
      '& .csg-tui-icon:last-child': {
        color: 'primary'
      }
    }, !props.isStatic && !props.isLoading ? {
      '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)': {
        bg: 'neutral.light'
      },
      '&:active:not(:disabled):not(:focus)': {
        bg: 'neutral.medium'
      }
    } : {});
  },
  buttonDropdown: function buttonDropdown(theme, props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles), standardBehavior(theme, props, 'primary')), {}, {
      bg: 'white',
      border: 'neutral',
      color: 'text-light-bg',
      '& .csg-tui-icon:last-child': {
        color: 'neutral.darker'
      },
      '&:hover:not(:disabled):not(.is-toggled):not(.disable-hover)': {
        border: 'black'
      },
      '&:active:not(:disabled):not(:focus)': {}
    });
  },
  text: (_text = {}, _defineProperty(_text, THEME_UI_DEFAULT_KEY, standardTextVariant), _defineProperty(_text, 'no-focus', function noFocus(theme, props) {
    var baseTheme = standardTextVariant(theme, props);
    return utils.omit(baseTheme, ['&:focus']);
  }), _text),
  ghost: {
    masthead: standardGhostVariant
  },
  'button-group-selected': function buttonGroupSelected(theme, props) {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles), standardBehavior(theme, props, 'primary')), {}, {
      bg: 'neutrals.21',
      border: 'neutral.medium',
      color: 'black',
      fontWeight: 'bold'
    });
  }
};

export default buttons;
//# sourceMappingURL=buttons.esm.js.map
